import OrganizationalRoutes from "./Organizational/Organizational.routes";
import OperationalRoutes from "./Operational/Operational.routes";
import Financial from "./Financial/Finance.routes";
import NotificationRoutes from "./Notification/Notification.routes";
import SettingRoutes from "./Setting/Setting.routes";

const PrivateRoutes = [
  OrganizationalRoutes,
  OperationalRoutes,
  Financial,
  NotificationRoutes,
  SettingRoutes
];

export default PrivateRoutes;
